var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 6.7C3.825 6.7 2.4 5.275 2.4 3.5C2.4 1.75 3.825 0.3 5.6 0.3C7.35 0.3 8.8 1.75 8.8 3.5C8.8 5.275 7.35 6.7 5.6 6.7ZM6.85 7.9C9.25 7.9 11.2 9.85 11.2 12.25C11.2 12.725 10.8 13.1 10.325 13.1H0.85C0.375 13.1 0 12.725 0 12.25C0 9.85 1.925 7.9 4.325 7.9H6.85ZM15.4 5.3C15.725 5.3 16 5.575 16 5.9C16 6.25 15.725 6.5 15.4 6.5H14.2V7.7C14.2 8.05 13.925 8.3 13.6 8.3C13.25 8.3 13 8.05 13 7.7V6.5H11.8C11.45 6.5 11.2 6.25 11.2 5.9C11.2 5.575 11.45 5.3 11.8 5.3H13V4.1C13 3.775 13.25 3.5 13.6 3.5C13.925 3.5 14.2 3.775 14.2 4.1V5.3H15.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileWhiteIcon);
export default __webpack_public_path__ + "static/media/profile-white-icon.5709e90469c35959d5819d6f8fb4f9a2.svg";
export { ForwardRef as ReactComponent };